import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';
import ProductStepperStep from './ProductStepperStep';

function CloseIcon(props) {
  return (
    <SvgIcon viewBox="0 0 16 16" style={{ color: '#fff', fontSize: 20 }} {...props}>
      <path d="M9.29297 7.75L13.7188 3.36719L14.6211 2.46484C14.75 2.33594 14.75 2.12109 14.6211 1.94922L13.6758 1.00391C13.5039 0.875 13.2891 0.875 13.1602 1.00391L7.875 6.33203L2.54688 1.00391C2.41797 0.875 2.20312 0.875 2.03125 1.00391L1.08594 1.94922C0.957031 2.12109 0.957031 2.33594 1.08594 2.46484L6.41406 7.75L1.08594 13.0781C0.957031 13.207 0.957031 13.4219 1.08594 13.5938L2.03125 14.5391C2.20312 14.668 2.41797 14.668 2.54688 14.5391L7.875 9.21094L12.2578 13.6367L13.1602 14.5391C13.2891 14.668 13.5039 14.668 13.6758 14.5391L14.6211 13.5938C14.75 13.4219 14.75 13.207 14.6211 13.0781L9.29297 7.75Z" />
    </SvgIcon>
  )
}
function WhiteboardIcon(props) {
  return (
    <SvgIcon viewBox="0 0 44 44" style={{ color: '#fff', fontSize: 34}} {...props}>
      <path d="M39.0625 32H37.75V11C37.75 10.0703 36.9297 9.25 36 9.25H8C7.01562 9.25 6.25 10.0703 6.25 11V32H4.9375C4.66406 32 4.5 32.2188 4.5 32.4375V33.3125C4.5 33.5859 4.66406 33.75 4.9375 33.75H39.0625C39.2812 33.75 39.5 33.5859 39.5 33.3125V32.4375C39.5 32.2188 39.2812 32 39.0625 32ZM20.25 32V28.5H30.75V32H20.25ZM32.5 32V28.5C32.5 27.5703 31.6797 26.75 30.75 26.75H20.25C19.2656 26.75 18.5 27.5703 18.5 28.5V32H8V11H36V32H32.5Z" />
    </SvgIcon>
  )
}
function ShapesIcon(props) {
  return (
    <SvgIcon viewBox="0 0 44 44" style={{ color: '#fff', fontSize: 34}} {...props}>
      <path d="M34.25 23.25H25.5C24.5156 23.25 23.75 24.0703 23.75 25V33.75C23.75 34.7344 24.5156 35.5 25.5 35.5H34.25C35.1797 35.5 36 34.7344 36 33.75V25C36 24.0703 35.1797 23.25 34.25 23.25ZM34.25 33.75H25.5V25H34.25V33.75ZM15 21.5C11.1172 21.5 8 24.6719 8 28.5C8 32.3828 11.1172 35.5 15 35.5C18.8281 35.5 22 32.3828 22 28.5C22 24.6719 18.8281 21.5 15 21.5ZM15 33.75C12.1016 33.75 9.75 31.3984 9.75 28.5C9.75 25.6562 12.1016 23.25 15 23.25C17.8438 23.25 20.25 25.6562 20.25 28.5C20.25 31.3984 17.8438 33.75 15 33.75ZM35.6719 18.5469L29.875 8.53906C29.4375 7.88281 28.7812 7.5 28.125 7.5C27.4141 7.5 26.7578 7.88281 26.3203 8.53906L20.5234 18.5469C19.7031 19.8594 20.6875 21.5 22.2734 21.5H33.9219C35.5078 21.5 36.4922 19.8594 35.6719 18.5469ZM34.1953 19.6406C34.1406 19.75 34.0312 19.75 33.9219 19.75H22.2734C22.1641 19.75 22.0547 19.75 22 19.6406C21.9453 19.5312 22 19.4219 22 19.4219L27.8516 9.41406C27.9062 9.30469 27.9609 9.25 28.125 9.25C28.2344 9.25 28.2891 9.30469 28.3438 9.41406L34.1953 19.4219C34.1953 19.4219 34.25 19.5312 34.1953 19.6406Z" />
    </SvgIcon>
  )
}
function LettersIcon(props) {
  return (
    <SvgIcon viewBox="0 0 44 44" style={{ color: '#fff', fontSize: 34}} {...props}>
      <path d="M39.0625 16.25H38.1875C37.9141 16.25 37.75 16.4688 37.75 16.6875V18.7109C36.4375 17.2344 34.5781 16.25 32.5 16.25C28.6172 16.25 25.5 19.4219 25.5 23.25V25C25.5 28.8828 28.6172 32 32.5 32C34.5781 32 36.4375 31.0703 37.75 29.5938V31.5625C37.75 31.8359 37.9141 32 38.1875 32H39.0625C39.2812 32 39.5 31.8359 39.5 31.5625V16.6875C39.5 16.4688 39.2812 16.25 39.0625 16.25ZM37.75 25C37.75 27.8984 35.3438 30.25 32.5 30.25C29.6016 30.25 27.25 27.8984 27.25 25V23.25C27.25 20.4062 29.6016 18 32.5 18C35.3438 18 37.75 20.4062 37.75 23.25V25ZM15.4375 11.5469C15.3281 11.2734 14.9453 11 14.6172 11H13.5781C13.25 11.0547 12.8672 11.2734 12.7578 11.5469L4.5 31.3984C4.5 31.4531 4.44531 31.5625 4.44531 31.5625C4.44531 31.8359 4.66406 32 4.88281 32H4.9375H5.86719C6.03125 32 6.19531 31.8906 6.25 31.7812L9.03906 25H19.1562L21.9453 31.7812C22 31.8906 22.1641 32 22.3281 32H23.3125C23.5312 32 23.75 31.8359 23.75 31.5625C23.75 31.5625 23.6953 31.4531 23.6953 31.3984L15.4375 11.5469ZM9.80469 23.25L14.125 12.9141L18.3906 23.25H9.80469Z" />
    </SvgIcon>
  )
}
function LetterCombinationIcon(props) {
  return (
    <SvgIcon viewBox="0 0 44 44" style={{ color: '#fff', fontSize: 34}} {...props}>
      <path d="M8.73438 11.5703V9H6V11.5703H8.73438ZM8.46094 14.9609H6.21875V29.0703H8.46094V14.9609Z" fill="white"/>
      <path d="M22.9766 20.2109C22.9766 16.4922 21.2812 14.6328 17.8906 14.6328C15.7031 14.6328 13.8984 15.6719 13.0234 17.5312L12.8047 14.9609H10.6719C10.7812 16.1641 10.8906 17.4766 10.8906 18.9531V29.0703H13.1328V21.0312C13.1328 18.2969 14.8828 16.5469 17.4531 16.5469C19.6953 16.5469 20.7344 17.75 20.7344 20.3203V29.0703H22.9766V20.2109Z" fill="white"/>
      <path d="M35.4141 17.4219C34.5391 15.6719 32.8438 14.6328 30.6016 14.6328C26.8281 14.6328 24.3125 17.4766 24.3125 21.6328C24.3125 25.8438 26.8281 28.6328 30.6016 28.6328C32.8438 28.6328 34.5391 27.5938 35.4141 25.8438V29.1797C35.4141 31.9688 34.0469 33.4453 31.3125 33.4453C29.3984 33.4453 27.9766 33.0078 26.1719 32.0234L25.7891 33.8828C27.3203 34.8125 29.1797 35.3047 31.3125 35.3047C35.4688 35.3047 37.6562 33.1172 37.6562 28.9609V14.9609H35.4141V17.4219ZM35.4141 21.6328C35.4141 24.8047 33.7734 26.7734 31.0391 26.7734C28.25 26.7734 26.6094 24.8047 26.6094 21.6328C26.6094 18.4609 28.25 16.5469 31.0391 16.5469C33.7734 16.5469 35.4141 18.4609 35.4141 21.6328Z" fill="white"/>
    </SvgIcon>
  )
}
function ClipartIcon(props) {
  return (
    <SvgIcon viewBox="0 0 44 44" style={{ color: '#fff', fontSize: 34}} {...props}>
      <path d="M33.375 11H10.625C9.14844 11 8 12.2031 8 13.625V29.375C8 30.8516 9.14844 32 10.625 32H33.375C34.7969 32 36 30.8516 36 29.375V13.625C36 12.2031 34.7969 11 33.375 11ZM34.25 29.375C34.25 29.8672 33.8125 30.25 33.375 30.25H10.625C10.1328 30.25 9.75 29.8672 9.75 29.375V13.625C9.75 13.1875 10.1328 12.75 10.625 12.75H33.375C33.8125 12.75 34.25 13.1875 34.25 13.625V29.375ZM14.125 20.1875C15.7656 20.1875 17.1875 18.8203 17.1875 17.125C17.1875 15.4844 15.7656 14.0625 14.125 14.0625C12.4297 14.0625 11.0625 15.4844 11.0625 17.125C11.0625 18.8203 12.4297 20.1875 14.125 20.1875ZM14.125 15.8125C14.8359 15.8125 15.4375 16.4141 15.4375 17.125C15.4375 17.8906 14.8359 18.4375 14.125 18.4375C13.3594 18.4375 12.8125 17.8906 12.8125 17.125C12.8125 16.4141 13.3594 15.8125 14.125 15.8125ZM25.4453 17.125L20.25 22.3203L18.5 20.625C18.0078 20.0781 17.1875 20.0781 16.6953 20.625L11.8828 25.4375C11.6641 25.6016 11.5 26.0391 11.5 26.3125V27.8438C11.5 28.2266 11.7734 28.5 12.1562 28.5H31.8438C32.1719 28.5 32.5 28.2266 32.5 27.8438V22.8125C32.5 22.4844 32.3359 22.1562 32.0625 21.9375L27.25 17.125C26.7578 16.5781 25.9375 16.5781 25.4453 17.125ZM30.75 26.75H13.25V26.5312L17.625 22.1562L20.25 24.7812L26.375 18.6562L30.75 23.0312V26.75Z" />
    </SvgIcon>
  )
}

const ProductStepper = ({
  onClickStep,
  activeStep,
  onClickClose,
}) => {
  return (
    <div className="product-stepper">
      <div>
        <ProductStepperStep
          stepName="SHAPES"
          activeStep={activeStep}>
          <ShapesIcon onClick={() => onClickStep('SHAPES')} />
        </ProductStepperStep>
        
        <ProductStepperStep
          stepName="LETTERS"
          activeStep={activeStep}>
          <LettersIcon onClick={() => onClickStep('LETTERS')} />
        </ProductStepperStep>
        
        <ProductStepperStep
          stepName="LETTER_COMBINATIONS"
          activeStep={activeStep}>
          <LetterCombinationIcon onClick={() => onClickStep('LETTER_COMBINATIONS')} />
        </ProductStepperStep>
        
        <ProductStepperStep
          stepName="CLIPART"
          activeStep={activeStep}>
          <ClipartIcon onClick={() => onClickStep('CLIPART')} />
        </ProductStepperStep>

        <ProductStepperStep
          stepName="BANNERS"
          activeStep={activeStep}>
          <WhiteboardIcon onClick={() => onClickStep('BANNERS')} />
        </ProductStepperStep>
      </div>

      <div className="product-stepper-actions">
        <CloseIcon className="product-stepper-action" onClick={onClickClose} />
      </div>
    </div>
  );
};

ProductStepper.propTypes = {
  onClickStep: PropTypes.func.isRequired,
  activeStep: PropTypes.string.isRequired,
  onClickClose: PropTypes.func.isRequired,
};

export default ProductStepper;
